import { createRouter, createWebHistory } from 'vue-router'
import TopComponent from '../components/TopComponent.vue'
import IntroductionComponent from '../components/IntroductionComponent.vue'
import StoryComponent from '../components/StoryComponent.vue'
import CastComponent from '../components/CastComponent.vue'
import DirectorsComponent from '../components/DirectorsComponent.vue'
import SoundtrackComponent from '../components/SoundtrackComponent.vue'
import CreditsComponent from '../components/CreditsComponent.vue'
import TheaterComponent from '../components/TheaterComponent.vue'
import TrailerComponent from '../components/TrailerComponent.vue'
const routes = [
  {
    path: '/',
    name: 'Top',
    component: TopComponent
  },
  {
    path: '/top',
    name: 'Top',
    component: TopComponent
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: IntroductionComponent
  },
  {
    path: '/story',
    name: 'Story',
    component: StoryComponent
  },
  {
    path: '/cast',
    name: 'Cast',
    component: CastComponent
  },
  {
    path: '/directors',
    name: 'Directors',
    component: DirectorsComponent
  },
  {
    path: '/soundtrack',
    name: 'Soundtrack',
    component: SoundtrackComponent
  },
  {
    path: '/credits',
    name: 'Credits',
    component: CreditsComponent
  },
  {
    path: '/theater',
    name: 'Theater',
    component: TheaterComponent
  },
  {
  path: '/trailer',
  name: 'trailer',
  component: TrailerComponent
  }

]

const router = createRouter({
  history: createWebHistory('/ibara/'),
  routes
})

export default router